import { groupMemberWording } from "../variable-config";

export default {
  title: "myCareBase",

  login: "Sign in",
  loginProgress: "Signing in...",
  postLoginProgress: "Loading profile...",
  loginWrongPassword: "Incorrect username or password.",
  loginUnverified:
    "Please verify your email address before proceeding signing in.",
  loginFailure: "Sign in failed!",
  loginFieldUsername: "Username, or Email, or Phone",
  loginFieldPassword: "Password",
  loginLinkRegister: "Create an account",
  loginLinkReset: "Trouble signing in",

  registration: "registration",
  registrationProgress: "Creating your account...",
  registrationSuccess:
    "Your account has been created! Please check your email for further instructions.",
  registrationFailure: "Sign-up failed",
  registrationUniqueFields: {
    email: "email",
    username: "username"
  },
  registrationUniqueExists: "already exists.",
  registrationConfirmPassword: "Confirm your password",
  registrationPasswordErrorLowerNum8:
    "Password must be at least 8 characters with numbers and letters",
  registrationPasswordNotMatch: "Password does not match",
  registrationAgreement: "Will open agreement page.",

  verificationSuccess:
    "You have successfully verified your account! Please proceed to sign in.",
  verificationFailure: "Verification failed",
  verificationExpiry: "Your verification link is invalid or expired!",
  verificationAlready:
    "This verification link has already been used. If you have completed verification, please proceed to sign in.",

  entryRequiring: "Enter",
  entryRequiringSingular: "Enter a",
  entryRequiringValid: "Enter a valid",

  clientLoading: "Refreshing",

  success: "success",
  comingSoon: "Coming soon.",
  pleaseWait: "Please wait...",
  checkEntries: "Please review your entries.",

  password: "password",
  drawer: "Side Menu",
  drawerGroupLabel: "Your roles and groups",
  marketplace: "Marketplace",
  settings: "Settings",
  logout: "Sign out",
  typeRoleGroupIndicator: "Role",
  newGroup: "New role or group",

  invite: "invite",
  invitation: "invitation",
  rejectOwnInvitation: "Sorry, you cannot accept your own invitation.",
  pendingInvitation:
    "You have new invitation awaiting,\nwould you like to view them now?",

  generalConfirm: "Ok",
  generalCancel: "Cancel",
  generalYes: "Yes",
  generalNo: "No",
  generalNext: "Next",
  generalAccept: "Yes",
  generalDeny: "No",

  pageNotExist: "Page does not exist.",
  chatNotExist: "The chat no longer exist.",

  marketShortlist: "Shortlist",
  marketShortListPickerLabel: "Add candidates to this shortlist:",
  marketNewShortlist: "New shortlist",
  marketNewShortlistInputPlaceholder: "New shortlist name",
  marketNewShortlistInput: "Name of new shortlist",
  marketDefaultShortlistName: "Shortlist 1",
  marketEditShortlistName: "Edit shortlist name",
  marketTabCriteria: "Search\ncriteria",
  marketTabSearch: "Search\nresults",
  marketTabCandidates: "Shortlisted\ncandidates",
  marketSearchNoMatch:
    "Sorry, we could not find a match for your search criteria.",
  marketCandidateNoMatch: "No candidates to show.",
  marketResetCriteria: "Reset criteria",
  marketSaveCriteria: "Save to profile",
  marketSeeSearchResults: "See search results",
  marketAddToShortlist: "Add to shortlist",
  marketAlreadyInShortlist: "Added to shortlist",
  marketTopicRemoveDeny: "Candidate cannot be removed when there are messages.",

  memberSelf: "Me",
  memberPending: "Pending",

  group: "group",
  topic: "topic",
  profile: "profile",
  chat: "chat",
  setup: "setup",
  details: "details",

  groupTabDashboard: "Dashboard",
  groupTabCaregiving: "caregiving",
  groupTabCaregivingTab: "Caregiving tab",
  groupMemberWording: groupMemberWording,

  adminCentre: `Admin Centre`,
  adminCentreNothingToShow: groupTypeNamePlural =>
    `No ${groupTypeNamePlural} to show`,
  adminCentreCardStatus: "Status",
  adminCentreCardFirstContactDate: "First contacted on",
  adminCentreCardQuestionnaireCompleteDate: "Questionnaire completed on",
  adminCentreCardQuestionnaireScorePercent: "Questionnaire score",
  adminCentreCardQuestionnaireResponses: "Questionnaire responses",
  adminCentreCardJobReferenceContactDate: "References contacted on",
  adminCentreCardJobReferenceResponseCount: "References responded",
  adminCentreCardJobReferenceResponseDetail: "References response details",
  adminCentreCardInterviewDate: "Interview date",
  adminCentreCardInterviewDateCheckCalendar: "Refer to your calendar",
  adminCentreCardInterviewBookedDate: "Interview booked on",
  adminCentreCardReferenceReceivedDate: "References received on",
  adminCentreCardReferenceCheckedDate: "References checked on",
  adminCentreCardBackgroundCheckedDate: "Background check received on",
  adminCentreCardBackgroundCheckedFiles: "Background check files",
  adminCentreCardApprovalDate: "Approved on",
  adminCentreCardProfileCompletionDate: "Profile completed on",
  adminCentreCardApprovedForMarketplaceDate: "Approved for Marketplace on",
  adminCentreCardBusinessName: "Business name",
  adminCentreCardJoinedDate: "Joined on",
  adminCentreCardFormedDate: "Formed on",
  adminCentreCardAcceptedTerms: "Accepted terms?",
  adminCentreCardCaregiverApproval: "Caregiver approved?",
  adminCentreCardCaregiverApproved: isApproved =>
    isApproved ? "Approved" : "Unapproved",
  adminCentreCardProvince: "Province",
  adminCentreCardTerritory: "Territory",
  adminCentreCardCity: "City",
  adminCentreCardCareReceiver: "Care Recipient",
  adminCentreCardRelationship: "Relationship",
  adminCentreCardOwner: "Contact",
  adminCentreSortByDate: "Sort by date",
  adminCentreSortByName: "Sort by name",
  adminCentreShowHideAvatar: hide => `${hide ? "Show" : "Hide"} avatars`,
  adminCentreTimeSheetMode: enabled =>
    `${enabled ? "Disable" : "Enable"} timesheet mode`,
  adminCentreTimeSheetModeText:
    "Click on a card to see the Timesheets of the Caregivers from the Care Circle.",
  adminCentreExitTimeSheetMode: "Back to Care Circles",
  adminCentrePayroll: "Payroll",
  adminCentreTimeSheets: "Care Circle Timesheets",
  adminCentreInvoicesGen: "Pending Payroll Processing",
  adminCentreInvoicesReRun: "Re-run Pending Payroll Processing",
  adminCentreInvoicesReRunHelp: [
    "Re-runs automatic approval for overdue eligible Pending Timesheets.",
    "Sweeps approved Timesheets that are not yet linked to an Invoice in order to create or update the appropriate Stripe draft Invoice."
  ],
  adminCentreAssignMissedCompletedShifts: "Assign Missed Completed Shifts",
  adminCentreAssignMissedCompletedShiftsHelp:
    "Finds recently completed Shifts that were missed during payroll rollout and adds them to the appropriate Timesheet using the current assignment rules.",
  adminCentreInvoicesReRunSuccess:
    "Pending payroll processing re-run complete. Please check the email sent to Admins for more details.",
  adminCentreInvoicesReRunNoData: "No pending payroll processing items.",
  adminCentreAssignMissedCompletedShiftsSuccess:
    "Missed completed Shift assignment is complete.",
  adminCentreAssignMissedCompletedShiftsNoData:
    "No recently completed Shifts need assignment.",
  adminCentreTimesheetGen: "Timesheet Generation",
  adminCentreTimesheetGenTrigger: "Trigger Timesheet generation",
  adminCentreTimesheetGenHelp:
    "Biweekly: Every 14 days, anchored to origin 2019-07-20; windows are auto-computed per group timezone.\n\nSemi-monthly: 1–15 and 16–end of month; windows auto-computed per group timezone.\n\nFree ranged: Admin supplies both start and end dates; interpreted in each group’s timezone (full local days).",
  adminCentreTimesheetGenHelp2:
    "Biweekly and Semi‑monthly runs are handled by the scheduler; use these modes manually only to backfill a missed or failed period.",
  adminCentreTimesheetGenSuccess:
    "Timesheet generation complete. Please check the email sent to Admins, PFCs, and Group owners for more details.",
  adminCentreSubscriptionInfo: "Subscription information",
  adminCentreProfile: typeName => `${typeName} Profile`,
  adminCentreDeleteGroupConfirm: (groupTypeName, groupName, subscriptionName) =>
    `Are you sure you want to delete ${groupTypeName}: ${groupName}?${
      subscriptionName
        ? `\n\nThe subscription of this ${groupTypeName} will also be cancelled:\n${subscriptionName}`
        : ""
    }`,
  adminCentreDeleteGroupNotify: groupName =>
    `Inform members of ${groupName} about this deletion.`,
  adminCentreDeleteGroupRefund:
    "Refund unused time on the current pre-paid plan.",
  adminCentreDeleteGroupSuccess: groupName => `${groupName} has been deleted.`,
  adminCentreTerritories: "Territories",
  adminCentreLocalities: "Localities",
  adminCentreLegacyTerritoriesTitle: "Legacy Territories and Municipalities",
  adminCentreTerritoriesTitle: "Territories and Municipalities",
  adminCentreCareCircleProvinces: "Care Circle Provinces",
  adminCentreTerritorySelectProv: "Select a province",
  adminCentreTerritorySelectTerri: "Select or add a territory",
  adminCentreTerritoryAddTerri: "New territory...",
  adminCentreTerritoryAddTerriName: "Territory name",
  adminCentreTerritoryDupName: (territory, province) =>
    `${territory} already exists in ${province}.`,
  adminCentreTerritoryAddTerriTimezone: "Time zone of territory",
  adminCentreTerritoryAddTerriInitMuni: "Name of first municipality",
  adminCentreTerritoryAddTerriInitMuniFooter:
    "You can add other municipalities later in the list.",
  adminCentreTerritoryAddMunicipality: "Add a municipality",
  adminCentreTerritoryAddMunicipalityName: "Name of municipality",
  adminCentreTerritoryRenameMunicipality: "Rename municipality",
  adminCentreTerritoryRemoveMunicipality: "Remove municipality",
  adminCentreTerritoryRemoveMunicipalityConfirm: (municipality, territoriy) =>
    `Are you sure you want to remove ${municipality} from ${territoriy}?`,
  adminCentreTerritoryRemoveMunicipalityInUse: municipality =>
    `${municipality} is being used by some users in the system therefore cannot be removed. Please rename ${municipality}, or pick a replacement municipality.`,
  adminCentreTerritoryReplaceMunicipality: "Replace municipality",
  adminCentreTerritoryReplaceMunicipalityPick: "Pick a replacement",
  adminCentreTerritoryMunicipalitiesOf: territory =>
    `Municipalities of ${territory}`,
  adminCentreTerritoryMunicipalityRename: "Rename",
  adminCentreTerritoryMunicipalityRemove: "Remove",
  adminCentrePromo: "Promo",
  adminCentrePromoList: "Promo List",
  adminCentrePayrollOption: "Change payroll option",
  adminCentreUseExternalPayrollProcessing: "Use external payroll processing",
  adminCentreServiceType: "Service type",
  adminCentreGainLossAccessOwnGroup:
    "Cannot gain / lose access to self-owned group",
  adminCentreTriggerRnR: "Trigger R&R invitation",
  adminCentreTriggerRnRCareCircle:
    "Trigger review for the following Care Circle members:",
  adminCentreTriggerRnRReviewerGroup:
    "Send review invitation to the following Care Circle(s) or Household(s):",
  adminCentreTriggerRnRRoleNameMap: {
    "Paid Caregiver": "Paid Caregiver(s)—has shift(s)",
    Cleaner: "Paid Cleaner(s)—has shift(s)",
    Handyman: "Service Provider - Handyman",
    Cleaning: "Service Provider - Cleaning",
    Transportation: "Service Provider - Transportation"
  },
  adminCentreTriggerRnRNoAvailableMember:
    "No Caregiver(s) or Service Provider(s) available for R&R.",
  adminCentreTriggerRnRNoAvailableGroup: isProvider =>
    `No available Care Circle or Household to review this ${
      isProvider ? "Caregiver" : "Service Provider"
    }.`,
  adminCentreTriggerRnRSuccess: isMultiple =>
    `R&R invitation${isMultiple ? "s" : ""} sent successfully!`,
  adminCentreViewRatingReview: "View Review & Ratings",
  adminCentreRatingReviewGivenBy: (name, groupTypeName) =>
    `Reviews & Ratings from ${groupTypeName} ${name}`,
  adminCentreRatingReviewOf: (name, groupTypeName) =>
    `Reviews & Ratings given to ${groupTypeName} ${name}`,
  adminCentreRatingReviewTargetMember:
    "Set admin rating, add testimonials, or view R&Rs given to Caregiver/Service Provider:",
  adminCentreRatingReviewSelectTargetMember: "Select a member",
  adminCentreSetAdminRating: "Set admin rating",
  adminCentreAddTestimonials: "Testimonials",
  adminCentreNoRatingReviews: "No R&Rs to show at this time.",
  adminCentreNoTestimonials: "No testimonials to show at this time.",
  adminCentreTestimonialReviewerPlaceholder: "Testimonial name",
  adminCentreNewTestimonialPlaceholder: "Enter testimonial review here",
  adminCentreRnRRequestReviewerGroupName: (groupName, isDisabled) =>
    `${groupName}${isDisabled ? ` (No shift done)` : ""}`,
  adminCentreJobPosting: "Jobs",
  adminCentreLoadingJobs: "Loading jobs page...",

  chatMessageEmpty: "No messages yet.",
  chatMessageEnd: "End of messages.",
  chatNewMessage: "New message has arrived, view it now?",

  reportCompletedShift: "Timesheet (Completed Shifts Summary)",
  reportCompletedShiftDisapprv: "Disapprove",
  reportCompletedShiftApprv: "Approve",
  reportCompletedShiftConfirm: isApproved =>
    `${isApproved ? "Approve" : "Disapprove"} this report?`,
  reportCompletedShiftDisapprvReasonTitle: "Disapproval reason",
  reportCompletedShiftDisapprvReasonPrompt:
    "Please enter the reason for disapproving this Timesheet before continuing.",
  reportCompletedShiftDisapprvReasonPlaceholder: "Enter the disapproval reason",

  profileSaving: "Saving profile...",
  profileEdit: "edit",

  setupComplete: "Complete",
  setupFinish: "Finish",
  setupGeneralFinishMsg: "Thank you for your information"
};
